import BigNumber from 'bignumber.js'

import { Array, BigNumber as BigNumber_, Option } from '@blade/std-lib'

export const bigintToBigNumber = (input: string | bigint, decimals: number) => {
  // It BN missing bigint typings
  const bigint = BigInt(input)
  const bn = BigNumber(bigint as unknown as number)
  const divider = BigNumber(10).exponentiatedBy(decimals)
  return bn.dividedBy(divider)
}

export const safeBigNumber = (
  input: BigNumber.Value,
  fallback: BigNumber.Value,
) => {
  return BigNumber_.make(input).pipe(
    Option.getOrElse(() => BigNumber_.makeUnsafe(fallback)),
  )
}

export const parseBigNumber = (input: string) => {
  return BigNumber_.parse(input).pipe(Option.getOrElse(() => undefined))
}

export const eqBigNumber = BigNumber_.equivalence

export const safeParseFloat = (input: string) => {
  const result = parseFloat(input)
  if (isNaN(result)) {
    return undefined
  }
  return result
}

export const eqBigNumberArray = Array.makeEquivalence(eqBigNumber)
